import { NotificationsListAnscOperator } from 'civil-status/view-models/notifications-list-ansc-operator';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<
  NotificationsListAnscOperator,
  keyof NotificationsListAnscOperator
>[] = [
  {
    id: 'holders',
    label: 'Intestatario',
  },
  {
    id: 'municipalityFormation',
    label: 'Comune di formazione',
  },
  {
    id: 'sourceEvent',
    label: 'Evento sorgente',
  },
  {
    id: 'municipalityDestination',
    label: 'Comune destinatario',
  },
  {
    id: 'register',
    label: 'Registro di destinazione',
  },
  {
    id: 'destinationAct',
    label: 'Atto di destinazione',
  },
  {
    id: 'ambito',
    label: 'Ambito',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'formationDate',
    label: 'Formazione',
  },
  {
    id: 'idAnsc',
    label: 'ID Ansc Notifica',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'operator',
    label: 'Operatore',
  },
  {
    id: 'idNotificationKind',
    label: 'Genere notifica',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
